<script type="text/javascript">

    import Login from './Login.vue';
    import LoginCode from './LoginCode.vue';
    import ChooseLoginUser from './ChooseLoginUser.vue';
    import ChooseLoginOrSignup from './ChooseLoginOrSignup.vue';
    import SignUp from './SignUp.vue';
    import {http} from '../../../system/http.js';

    export default {

        data: function () {

            return {
                loginSignupFlow: 'chooseLoginOrSignup',
                chooseFromLogin: true,
                loading: false,
                online_booking_settings: null,
                permalink: permalink,
                gmaps_url: null,
                loginDesc: null,
                logged_in: logged_in,
                user: {},
                settingsLogin: null,
                showCookieFixButton: false,
            }

        },

        computed: {
            queryRoute () {
                let { redirect_to } = this.$route.query;
                redirect_to = redirect_to === 'messages'
                    ? 'secure-messages'
                    : redirect_to;
                const doesRouteExist = this.$router.options.routes.some(route => route.name === redirect_to);
                return doesRouteExist ? redirect_to : null;
            }
        },

        mounted: function () {
            if (window.location.href.indexOf("redirect") > -1) {
                    this.loginSignupFlow = 'login';
            }

            if(this.logged_in){
                let routeName = this.queryRoute || 'your-page';
                this.$router.push({
                    name: routeName,
                    params: { permalink: this.permalink }
                });
            }else{
                this.init();
                this.$event_bus.$on('LoadUserData', (data) => {
                    this.user = data.user;
                    this.settingsLogin = data.settings_login;
                    if (this.settingsLogin && this.settingsLogin.allow_create === 0 || this.queryRoute) {
                        this.loginSignupFlow = 'login'
                    };
                });

                this.$event_bus.$on('LoadData', (data) => {
                    this.user = data.user;
                    this.settingsLogin = data.settings_login;
                });

                this.$event_bus.$on('LoadEventData', (data) => {
                    this.user = data.user;
                    this.settingsLogin = data.settings_login;
                });

                this.$event_bus.$on('goLogin', () => {
                    this.loginSignupFlow = 'login';
                });

                this.$event_bus.$on('goSignUp', () => {
                    this.loginSignupFlow = 'signUp';
                });

                this.$event_bus.$on('goLoginOrSignUp', () => {
                    this.loginSignupFlow = (this.chooseFromLogin) ? 'login' : 'signUp';

                });

                this.$event_bus.$on('codeSent', (data) => {
                    this.loginSignupFlow = 'loginCode';
                    this.$event_bus.$emit('codeSent2', data);
                });

                this.$event_bus.$on('chooseLoginUser', (data) => {
                    this.loginSignupFlow = 'chooseLoginUser';
                    this.$event_bus.$emit('chooseLoginUser2', data);
                });

                this.$event_bus.$on('goBackToChoose', () => {
                    this.loginSignupFlow = 'chooseLoginOrSignup';
                });

                this.$event_bus.$on('beforeCode', (beforeCodeValue) => {
                    this.chooseFromLogin = beforeCodeValue === 'login';
                });
            }

        },

        components: {
            Login: Login,
            LoginCode: LoginCode,
            SignUp: SignUp,
            ChooseLoginUser: ChooseLoginUser,
            ChooseLoginOrSignup: ChooseLoginOrSignup
        },

        methods: {
            init: function () {
                this.loading = true;

                http.get('/book/' + this.permalink + '/center/get')
                    .then(({data}) => {
                        if (data.cookie_fix_required) {
                            this.loading = false;
                            this.fixCookie(data.online_booking_url, data.url, data.online_booking_url);
                            return;
                        }

                        this.online_booking_settings = data.online_booking_settings;
                        this.user = data.user;
                        this.gmaps_url = data.gmaps_url;
                        this.$event_bus.$emit('LoadUserData', data);
                        this.loginDesc = data.settings_login.description_formatted;

                        this.loading = false;
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                    });
            },

            fixCookie(expectedUrl, popupUrl, redirect) {
                var expectedUrl = `${expectedUrl}?cookie_fixed=1`;

                window.AutomaticallyClosingPopupLink.configure('cookie-fix-button', expectedUrl, popupUrl, redirect);
                this.showCookieFixButton = true;
            },
        },
    };
</script>


<template id="subpage-login">
    <div>

        <div class="text-center" v-show="loading">
            <div class="preloader"></div>
        </div>

        <div v-show="!loading && !showCookieFixButton">
            <div class="row" v-if="loginDesc">
                <div class="col-sm-12">
                    <div class="jumbotron-login m-b-20">
                        <span v-sanitize-html="loginDesc"></span>
                    </div>
                </div>
            </div>
            <transition-group name="slideUp">
                <choose-login-or-signup key="choose-login-or-signup" v-show="loginSignupFlow == 'chooseLoginOrSignup' && settingsLogin && settingsLogin.allow_create"></choose-login-or-signup>
                <login key="login" v-show="loginSignupFlow == 'login'" class="row"></login>
                <login-code key="login-code" v-show="loginSignupFlow == 'loginCode'" class="row"></login-code>
                <choose-login-user :choose-from-login="chooseFromLogin" key="choose-login-user" v-show="loginSignupFlow == 'chooseLoginUser'" class="row"></choose-login-user>
                <sign-up key="signup" v-show="loginSignupFlow == 'signUp'" class="row"></sign-up>
            </transition-group>

        </div>

        <div v-show="showCookieFixButton" class="text-center">
            <ep-banner class="m-t-30 m-b-30">{{ trans('online_booking.iframe_cookies_blocked') }}</ep-banner>

            <button id="cookie-fix-button" class="btn btn-custom">{{ trans('online_booking.iframe_cookies_blocked_cta') }}</button>

            <p class="m-t-30"><a href="" target="_blank">{{ trans('online_booking.iframe_cookies_blocked_second_cta') }}</a></p>
        </div>

    </div>
</template>
